import axios from "axios";
import { API_LANDING_EADSTOCK } from "@/common/config";

const ApiLandingEadstock = {
  apiLandingEadstockAxios: null,
  init() {
    return new Promise(resolve => {
      this.apiLandingEadstockAxios = axios.create({
        baseURL: API_LANDING_EADSTOCK,
        headers: { "Content-Type": "application/json" }
      });

      /* this.apiLandingEadstockAxios.interceptors.response.use(
        this.responseInterceptor.bind(this),
        this.errorInterceptor.bind(this)
      ); */

      resolve();
    });
  },

  /* responseInterceptor(response) {
    return response;
  },

  errorInterceptor(error) {
    const that = this;

    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error);
    }

    if (
      !store.getters["auth/keycloak"].token ||
      !store.getters["auth/keycloak"].refreshToken
    ) {
      return new Promise((resolve, reject) => {
        store.getters["auth/keycloak"].logout();
        reject(error);
      });
    }

    return new Promise((resolve, reject) => {
      store.dispatch(`auth/${UPDATE_TOKEN}`).then(() => {
        that.setTokenHeader(store.getters["auth/keycloak"].token);
        const config = error.config;
        config.headers[
          "Authorization"
        ] = `Bearer ${store.getters["auth/keycloak"].token}`;
        that.apiLandingEadstockAxios
          .request(config)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            store.getters["auth/keycloak"].logout();
          });
      });
    });
  }, */

  post(resource, params) {
    return this.apiLandingEadstockAxios.post(`${resource}`, params);
  }
};

export default ApiLandingEadstock;
